module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "urban-heat.2826acd5.jpg";